import { render, staticRenderFns } from "./LabelOnlyTagDisplay.vue?vue&type=template&id=4dfc66dc&scoped=true&lang=html&"
import script from "./LabelOnlyTagDisplay.vue?vue&type=script&lang=js&"
export * from "./LabelOnlyTagDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfc66dc",
  null
  
)

export default component.exports